import { type FC, memo } from 'react';

import { Text } from '@livechat/design-system-react-components';

import * as styles from '../styles';

import { Context25SparkleIcon } from './Context25SparkleIcon';

export const Context25Message: FC = memo(() => {
  return (
    <>
      <Context25SparkleIcon />
      <Text className={styles.messageStyle}>
        <span>Meet Text App — your new all-in-one support workspace.</span>
      </Text>
    </>
  );
});

Context25Message.displayName = 'Context25Message';
